import axios from 'axios';
import {getUUID, getQueryString} from '@activity-business/h5-package-frameworkTool';

const http = axios.create({
    timeout: 1000 * 30,
});
//	请求拦截
http.interceptors.request.use(async config => {
	const apiDomain = window.ACTIVITY_H5_CONFIG?.fnGetRequestDomain(getQueryString('lang'));
	const defaultConfig = {
		nonce: getUUID(),
		timestamp: Date.now(),
		'Content-Type': 'application/json; charset=utf-8'
	};
    // header 合并。
    config.headers = Object.assign(config.headers, defaultConfig);
    // 请求完整链接
    config.url = apiDomain + config.url;
	return config;;
}, error => {
	return error;
});

export default http;
